










































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import AppConsts from '@/lib/appconst';
import PagedFilterAndSortedRequest from '@/store/entities/page-request';
import pagelist from '@/components/pagelistcomponent';
@Component({
    components: {}
})
export default class suppliermanage extends pagelist {
    get prox() {
        return new proxy.AgentStatisticsDayServiceProxy();
    }
    input: proxy.AgentStatisticsDayPageInputDto = new proxy.AgentStatisticsDayPageInputDto();
    createrange = [];
    agents = []
    columns = [
        {
            type: "selection",
            width: 60,
            align: "center",
        },
        {
            title: '代理',
            key: 'agentName'
        },
        {
            title: "统计日期",
            key: "statisticsTime",
        },
        {
            title: "成功金额",
            key: "successMoney",
        },
        {
            title: "成功订单数",
            key: "successCount",
        },
        {
            title: "代理费用",
            key: "agentMoney",
        },
        {
            title: '创建时间',
            slot: 'creationTime'
        }
    ];
    fetchDataList(
        request: PagedFilterAndSortedRequest,
        pageNumber: number,
        finishedCallback: Function
    ): void {
        this.input.skipCount = request.skipCount;
        this.input.maxResultCount = request.maxResultCount;
        this.input.sorting = request.sorting;
        this.input.startTime = this.createrange[0];
        this.input.endTime = this.createrange[1];
        this.prox.queryModelList(this.input).then(x => {
            this.dataList = x.items;
            this.showPaging(x);
        });
    }
    getpage() {
        this.OnInit();
    }
    async created() {
        var par = new proxy.AgentPageInputDto();
        par.maxResultCount = 9999;
        new proxy.AgentServiceProxy().queryModelList(par).then((x) => {
            this.agents = x.items;
        });
        this.getpage();
    }
}
